import ContactTypeDto from 'common/dto-types/contacts/job-title-dto';
import ListWithTotal from 'common/dto-types/list-with-total-dto';
import axiosServices, { FiltersAndSortingParams, buildFilterParams } from 'utils/axios';

const CONTACT_TYPES_API_URL = 'contactTypes';

export const fetchContactTypeList = async (
    params: FiltersAndSortingParams,
): Promise<ListWithTotal<ContactTypeDto> | null | undefined> => {
    try {
        const res = await axiosServices.get(`${CONTACT_TYPES_API_URL}${buildFilterParams(params)}`);
        return res.data;
    } catch (err) {
        // TODO: Implement a proper way to handle errors
        // https://fifadigital.atlassian.net/browse/FMH-2075
        console.error(err);
        return null;
    }
};

export const createContactType = async (contactType: ContactTypeDto): Promise<number | null | undefined> => {
    try {
        return await axiosServices.post(CONTACT_TYPES_API_URL, contactType).then((res) => res.data);
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const updateContactType = async (contactType: ContactTypeDto): Promise<number | null | undefined> => {
    try {
        return await axiosServices.put(CONTACT_TYPES_API_URL, contactType).then((res) => res.data);
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const deleteContactType = async (id: string): Promise<number | null> => {
    try {
        return await axiosServices.delete(`${CONTACT_TYPES_API_URL}/${id}`).then((res) => res.status);
    } catch (err) {
        console.error(err);
        return null;
    }
};
